import "../../../../assets/scss/login-style.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Col, message, Row } from "antd";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import { signupUser } from "../../../server/User";

const SignUpComponent: React.FC = () => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("Incorrect Email format"))
      .required(t("Please provide your Email")),
    password: Yup.string()
      .min(8, t("Password must be longer than 8 characters"))
      .required(t("Password field is required")),
    confirmPassword: Yup.string()
      .required(t("Confirm Password field is required"))
      .oneOf([Yup.ref("password")], t("Please make sure the passwords match")),
    readPolicy: Yup.string().required(
      t("Please agree to the terms in order to sign up")
    ),
  });

  const signUpSuccess = () => {
    messageApi.success({
      content: t("Sign Up Success!"),
    });
  };

  const signUpError = () => {
    messageApi.error({
      content: t("Sign Up Failed!"),
    });
  };

  return (
    <>
      {contextHolder}
      <div className="signup form">
        <Formik
          validateOnMount={true}
          enableReinitialize={true}
          validationSchema={SignupSchema}
          initialValues={{}}
          onSubmit={(values: any) => {
            signupUser({
              ...values,
              name: values.family_name + " " + values.given_name,
              picture: "",
            })
              .then((res) => {
                if (res.data.msg == "success") {
                  signUpSuccess();
                  setTimeout(() => {
                    navigate("/login");
                  }, 1000);
                }
              })
              .catch((res) => {
                console.log(res);
                signUpError();
              });
          }}
        >
          {({ errors, touched }) => (
            <Form>
              <div className="label-wrapper">
                <label htmlFor="email">{t("E-Mail")}</label>
                <Field
                  name="email"
                  type="email"
                  placeholder={t("E.g. neurowatt@gmail.com")}
                />
                <div className="form-error-msg">
                  <ErrorMessage name="email" />
                </div>
              </div>
              <div className="label-wrapper">
                <label htmlFor="password">{t("Password")}</label>
                <Field
                  name="password"
                  type="password"
                  placeholder={t("Enter Your Password")}
                />
                <div className="form-error-msg">
                  <ErrorMessage name="password" />
                </div>
              </div>
              <div className="label-wrapper">
                <label htmlFor="confirmPassword">{t("Confirm Password")}</label>
                <Field
                  name="confirmPassword"
                  type="password"
                  placeholder={t("Repeat Your Password")}
                />
                <div className="form-error-msg">
                  <ErrorMessage name="confirmPassword" />
                </div>
              </div>

              <div style={{ margin: "1em 0" }}>
                <Field name="readPolicy" type="checkbox" />
                {t("I've read and agreed to the terms and services")}
                <div className="form-error-msg">
                  <ErrorMessage name="readPolicy" />
                </div>
              </div>
              <p>
                <button className="sign-up-btn" type="submit">
                  {t("Sign Up")}
                </button>
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default SignUpComponent;
